// Generated from api/openapi/operations.yaml by make docs. Do not edit.
import { z } from "zod";

export const availableFrameworkSchema = z.object({
  "framework_id": z.string(),
  "framework_version": z.string(),
  "name": z.string(),
  "blurb": z.string().optional(),
  "jurisdiction": z.string().optional(),
  "region": z.string().optional(),
  "control_count": z.number().int().min(0),
  "measured_count": z.number().int().min(0),
  "by_design_count": z.number().int().min(0),
  "supported_count": z.number().int().min(0),
  "you_attest_count": z.number().int().min(0),
  "we_attest_count": z.number().int().min(0),
  "requires": z.array(z.string()).nullable(),
  "selected": z.boolean(),
  "selected_by_email": z.string().optional(),
  "selected_by_scope": z.enum(["tenant", "tenant_grant", "platform"]).optional(),
  "selected_at": z.string().datetime({ offset: true }).optional(),
  "offered": z.boolean(),
  "not_offered_reason": z.enum(["internal", "licence_unreviewed", "licence_blocked"]).optional(),
  "licence_status": z.enum(["reviewed", "unreviewed", "blocked"]),
  "verification": z.enum(["not_applicable", "unverified", "engineering_verified", "counsel_verified"])
});

export const frameworkSelectionSchema = z.object({
  "selected": z.array(z.object({
    "framework_id": z.string(),
    "framework_version": z.string(),
    "selected_by_email": z.string().optional(),
    "selected_by_scope": z.enum(["tenant", "tenant_grant", "platform"]).optional(),
    "selected_at": z.string().datetime({ offset: true })
  })),
  "available": z.array(availableFrameworkSchema)
});
